import {
  EventCard,
  EventImageWrap,
  EventImage,
  EventBody,
  EventTitle,
  EventCTA,
} from "./styled";

export const CharityBlock = (props: any) => {
  return (
    <EventCard>
      <EventImageWrap>
        <EventImage src={props.photo} alt={props.title} />
      </EventImageWrap>
      <EventBody>
        <EventTitle>{props.title}</EventTitle>
        <EventCTA>
          Подробнее
          <svg viewBox="0 0 14 10" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1 5H13M13 5L9 1M13 5L9 9"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
            />
          </svg>
        </EventCTA>
      </EventBody>
    </EventCard>
  );
};
